import api from '@/api';
import {
  CancellationCodeResponse,
  InvoiceCancelNfsRequest,
  InvoiceMailNfsRequest,
  InvoiceNFSAllPDFRequest,
  InvoiceTransmitNfsRequest,
} from './NfseController.types';
import { API_BASE_URL } from '..';

const CONTROLLER_URL = `${API_BASE_URL}/invoices`;

export async function CancellationCode(cityId: number) {
  const result = (await api.get(
    `${CONTROLLER_URL}/${cityId}/cancellation-code`,
    null,
  )) as unknown;

  return result as CancellationCodeResponse[];
}

export async function TransmitInvoiceNfs(params: InvoiceTransmitNfsRequest) {
  const query = new URLSearchParams();

  if (params.newNumber) {
    query.append('newNumber', String(params.newNumber));
  }

  const result = (await api.post(
    `${CONTROLLER_URL}/${params.invoiceId}/transmit?${query}`,
    {},
    null,
  )) as unknown;

  return result;
}

export async function CancelInvoiceNfs(params: InvoiceCancelNfsRequest) {
  const { invoiceId, ...obj } = params;

  return (await api.post(
    `${CONTROLLER_URL}/${invoiceId}/cancel`,
    obj,
    null,
  )) as unknown;
}

export async function ConsultInvoiceNfs(invoiceId: number) {
  const result = (await api.post(
    `${CONTROLLER_URL}/${invoiceId}/consult`,
    {},
    null,
  )) as unknown;

  return result as string;
}

export async function MailInvoiceNfs(params: InvoiceMailNfsRequest) {
  const { invoiceId, email } = params;

  const result = (await api.post(`${CONTROLLER_URL}/${invoiceId}/mail`, {
    email,
  })) as unknown;

  return result as void;
}

export async function PdfInvoiceNfs(invoiceId: number) {
  const result = (await api.getReport(
    `${CONTROLLER_URL}/${invoiceId}/pdf`,
    {},
  )) as unknown;

  return result as Blob;
}

export async function XmlInvoiceNfs(invoiceId: number) {
  const result = (await api.get(
    `${CONTROLLER_URL}/${invoiceId}/xml`,
    null,
  )) as unknown;

  return result as Blob;
}

export async function PdfPreviewInvoiceNfs(invoiceId: number) {
  const result = (await api.getReport(
    `${CONTROLLER_URL}/${invoiceId}/pdf-preview`,
    {},
  )) as unknown;

  return result as Blob;
}

export async function XmlPreviewInvoiceNfs(invoiceId: number) {
  const result = (await api.get(
    `${CONTROLLER_URL}/${invoiceId}/xml-preview`,
    null,
  )) as unknown;

  return result as Blob;
}

export async function invoiceNFSdownloadAllPDF(
  params: InvoiceNFSAllPDFRequest,
) {
  const result = (await api.getReport(
    `${CONTROLLER_URL}/all-pdf`,
    params,
  )) as unknown;
  return result as BlobPart;
}
